export const GOOGLE_CLIENT_ID = '393930515712-ni60cu14nokqq71oln7gmeprq8enq58f.apps.googleusercontent.com';

// Canonical public origin — every schedule link we copy or email uses this,
// no matter which host (vercel.app, custom domain) the admin happens to be on.
// Localhost keeps its own origin so local dev links stay clickable.
export const CANONICAL_ORIGIN = 'https://conference.thebelonging.co';
export function publicOrigin() {
  const origin = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
  if (origin.includes('localhost') || origin.includes('127.0.0.1')) return origin;
  return CANONICAL_ORIGIN;
}

export const ADMIN_EMAILS = [
  'rebeccamrice15@gmail.com',
];

// Returns true if this user is allowed to trigger email sends
export function canUserSend(email, role) {
  if (!email) return false;
  if (role === 'admin') return true;
  return email.endsWith('@thebelonging.co') || ADMIN_EMAILS.includes(email);
}

export const CONFERENCE_DATES = {
  start: '2026-09-12',
  end: '2026-09-20',
  preConfStart: '2026-08-20',
};

export const PASS_LEVELS = ['SL', 'AA Pass', 'Media Pass'];

export const TEAMS = [
  'Broadcast', 'Check In', 'College', 'Comms', 'Events',
  'Facilities', 'Film', 'Finance', 'Guest Relations', 'Guest Services',
  'Installation', 'IT', 'Kids', 'Leadership Co', 'Lighting',
  'Load In/Load Out', 'Merch', 'Online Team', 'Outreach', 'Production',
  'Security', 'SL Team', 'Transportation', 'Worship', 'Youth',
];
